
import { BasePageModal } from "@/shared/components/modal/page-modal/base-page-modal";
import { useTwoStepAuthSet } from "@/features/two-step-authentication/hooks/use-two-step-authentication-set";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";
import React, { useEffect } from "react";

interface Props {
  onTapCloseModal: () => void;
  onTapCompleteModal: () => void;
  setIsValid: React.Dispatch<React.SetStateAction<boolean>>;
}

// 2段階認証設定モーダル
export const TwoStepAuthSetModal = ({ onTapCloseModal, onTapCompleteModal, setIsValid }: Props) => {
  const {
    isValid,
    setTwoStepAuthValidState,
    onClickValid,
    onClickInvalid,
  } = useTwoStepAuthSet({ onTapCompleteModal});

  useEffect(() => {
    setTwoStepAuthValidState();
  }, []);

  return (
    <BasePageModal
      title="2段階認証の設定"
      className="md-user-2factor"
      handleClose={() => {
        onTapCloseModal();
      }}
    >
      <h2>2段階認証は{isValid === 1 ? "有効" : "無効"}になっています</h2>
        {isValid === 1 ? (
          <BaseRoundButton
            buttonText="無効にする"
            className="nav-main"
            onClick={() => {
              onClickInvalid(isValid);
              setIsValid(false);
            }}
          />
        ) : (
          <BaseRoundButton
            buttonText="有効にする"
            className="nav-main"
            onClick={() => onClickValid(isValid)}
          />
        )}
      <div className="message">
        {isValid === 1 ? (
          <p>無効にするとログイン毎の認証コードの入力が不要になります。</p>
        ) : (
          <>
            <p>2段階認証を有効にすると、ログイン時に認証コードを入力していただきます。</p>
            <p>アカウントを安全に保つため、有効化をおすすめします。</p>
          </>
        )}
      </div>
    </BasePageModal>
  );
};
